/**
 * Stage color mapping for protected system stages
 * Custom stages will use neutral gray styling
 */

/**
 * Get Tailwind color classes for stage badges
 * @param {string} stage - The stage name
 * @returns {string} Tailwind CSS classes for background and text color
 */
export const getStageColorClasses = (stage) => {
  const stageColorMap = {
    "New Lead": "bg-blue-100 text-blue-700",
    "In Progress": "bg-yellow-100 text-yellow-700",
    "Quoted": "bg-purple-100 text-purple-700",
    "Approved": "bg-emerald-100 text-emerald-700",
    "Booked": "bg-teal-100 text-teal-700",
    "Scheduled": "bg-indigo-100 text-indigo-700",
    "Completed": "bg-green-100 text-green-700",
    "Archived": "bg-gray-200 text-gray-700",
  };

  // Return mapped color or neutral gray for custom stages
  return stageColorMap[stage] || "bg-gray-100 text-gray-600";
};
